<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						기관통합
					</h2>
					<a href="#none" class="close" @click="$emit('close')">&times;</a>
				</div>
				<div class="modal-body p-10 clearfix" style="min-height: 100px;background-color: #f8f8f8;">
					<table class="table2 table-condensed table-hover m-t-10 text-center">
						<tbody>
							<tr class="on">
								<td>
									<input id="check1" class="checkbox" type="checkbox">
									<label for="check1" class="v-mid">체크버튼</label>
									<span class="text-blue v-mid">대표</span>
								</td>
								<td class="text-left">
									0000001
								</td>
								<td>
									행정기준코드
								</td>
								<td>지원기획단</td>
								<td>20명</td>
								<td>
									<a class="del" href="#">제거</a>
								</td>
							</tr>
							<tr class="margin">
								<td colspan="6"></td>
							</tr>
							<tr>
								<td>
									<input id="check1" class="checkbox" type="checkbox">
									<label for="check1" class="v-mid">체크버튼</label>
									<span class="text-blue v-mid">통합</span>
								</td>
								<td class="text-left">
									0000001
								</td>
								<td>
									사용자등록
								</td>
								<td>지원기획단</td>
								<td>20명</td>
								<td>
									<a class="del" href="#">제거</a>
								</td>
							</tr>
							<tr class="margin">
								<td colspan="6"></td>
							</tr>
							<tr>
								<td>
									<input id="check1" class="checkbox" type="checkbox">
									<label for="check1" class="v-mid">체크버튼</label>
									<span class="text-blue v-mid">통합</span>
								</td>
								<td class="text-left">
									0000001
								</td>
								<td>
									관리자등록
								</td>
								<td>지원기획단</td>
								<td>20명</td>
								<td>
									<a class="del" href="#">제거</a>
								</td>
							</tr>
							<tr class="margin">
								<td colspan="6"></td>
							</tr>
							<tr style="opacity: 0.4;">
								<td>
									<input id="check1" class="checkbox" type="checkbox">
									<label for="check1" class="v-mid">체크버튼</label>
									<span class="text-red v-mid">통합불가</span>
								</td>
								<td class="text-left">
									0000001
								</td>
								<td>
									행정기준코드
								</td>
								<td>지원기획단</td>
								<td>20명</td>
								<td>
									<a class="del" href="#">제거</a>
								</td>
							</tr>
						</tbody>
					</table>
					<span class="m-l-5">* 행정표준코드는 대표로만 설정이 가능하며, 행정표준코드 끼리는 통합이 불가능 합니다.</span>
				</div>
				<div class="modal-footer p-10" style="background-color: #f8f8f8;">
					<button class=" btn bg-deepblue full-width text-white round">통합</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "ModalInstitutionUnify",

	default: function() {
		return {
			name: this.name,
			show: false
		}
	},

	props: {
		config: Object
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>